import { Pipe, PipeTransform, LOCALE_ID } from '@angular/core';
import { formatCurrency } from '@angular/common';

@Pipe({
  name: 'appCurrency'
})
export class CurrencyPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    let prefix = args[0] || '';
    let nullValue = args[1] || '';
    
    try {
      let newValue = value.toString().replace( /[^0-9,.]/g,'')
      let filter:string = newValue.toString().replace( /[^,.]/g,'');

      if(!newValue) return nullValue;
  
      if(filter[filter.length-1] == ',') {
        return newValue;
      }
  
      if(filter[filter.length-1] == '.') {
        return formatCurrency(parseFloat(newValue), 'pt', prefix)
      }

      return newValue;
    
    } catch {
      return nullValue;
    }
  }

}
